/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_KeepInputs */

const en_withdrawal_keep = /** @type {(inputs: Withdrawal_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep it`)
};

const pl_withdrawal_keep = /** @type {(inputs: Withdrawal_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostaw`)
};

/**
* | output |
* | --- |
* | "Keep it" |
*
* @param {Withdrawal_KeepInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_keep = /** @type {((inputs?: Withdrawal_KeepInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_KeepInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_keep(inputs)
	return en_withdrawal_keep(inputs)
});